import { render } from "./MFITTTermsUrl.vue?vue&type=template&id=5390d6ea&scoped=true"
import script from "./MFITTTermsUrl.vue?vue&type=script&lang=js"
export * from "./MFITTTermsUrl.vue?vue&type=script&lang=js"

import "./MFITTTermsUrl.vue?vue&type=style&index=0&id=5390d6ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5390d6ea"

export default script